module.exports = __webpack_public_path__ + "img/undraw_blank_page.60a66db9.svg";